// src/firebase.js
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";  // Import Auth
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyDGEu8fLpjDZQ1YcqnsvRgmdqGvyuBTbqY",
  authDomain: "osl-app-21e84.firebaseapp.com",
  projectId: "osl-app-21e84",
  storageBucket: "osl-app-21e84.firebasestorage.app",
  messagingSenderId: "475286014021",
  appId: "1:475286014021:web:518edd4b65baf151b03b2c",
  measurementId: "G-HJ653XJY5X"
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);            // Initialize Auth
const db = getFirestore(app);         // Initialize Firestore

export { auth, db };
